export const MY_MEETINGS_LIMITS = 10;
export const TOPIC_LIMITS = 50;
export const MEETINGS_LIMITS = 50;
export const MESSAGES_LIMITS = 20;
